import { render } from "./PayrollList.vue?vue&type=template&id=54f5e00f&scoped=true"
import script from "./PayrollList.vue?vue&type=script&lang=js"
export * from "./PayrollList.vue?vue&type=script&lang=js"

import "./PayrollList.vue?vue&type=style&index=0&id=54f5e00f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54f5e00f"

export default script